<script setup lang="ts">
import { VContentGridItem, VIcons, VPreloader } from '@/shared/ui'
import './assets/style.scss'
import useModel from './../model/model'
import { useSseConnection } from '@/shared/lib'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

defineOptions({ name: 'protect' })

const { items, count, loadData } = useModel()
const { isPending, refetch } = loadData()
const route = useRoute()

/**
 * Получение класса иконки
 * @param value
 */
const getItemClass = (value: number) => {
  switch (value) {
    case -1:
      return 'protected-item__icon_inactive'
    case 0:
      return 'protected-item__icon_success'
    case 1:
      return 'protected-item__icon_error'
  }
}

/* Вычисляем количество разрешенных автоматов */
const protects = computed(() => {
  return [...items.value]
    .sort((a, b) => Number(a.id) - Number(b.id))
    .filter((item) => item.id <= count.value)
})

/* Устанавливаем SSE соединение */
const { handler } = useSseConnection(async (res: { pin_statuses?: any[] }) => {
  if (res.pin_statuses) refetch()
})

watch(
  () => route.params.object_id,
  () => {
    handler(`/cabinets/${route.params.object_id}/statuses`)
  },
  { immediate: true },
)
</script>

<template>
  <VContentGridItem :title="$t('itf.protect_title')" :visible="!!count" compact>
    <template v-if="isPending">
      <VPreloader />
    </template>

    <div v-else class="protected-item__grid">
      <div
        class="protected-item"
        :class="item.description ? 'protected-item_info' : ''"
        v-for="item in protects"
        :key="item.id"
      >
        <div class="protected-item__icon" :class="getItemClass(item.value)">
          <VIcons type="shield" bold />

          <div class="protected-item__num">{{ item.id }}</div>
        </div>

        <div v-if="item.description" class="protected-item__description">
          <VTooltip :text="item.description" open-delay="300" location="top">
            <template v-slot:activator="{ props }">
              <VIcons v-bind="props" type="info_i" />
            </template>
          </VTooltip>
        </div>
      </div>
    </div>
  </VContentGridItem>
</template>
